import { Injectable, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from '../internal-components/confirm-modal/confirm-modal.component';
import { LoginComponent } from '../internal-components/login/login.component';
import { ConfirmModalInfo, LoaderInfo, ToastInfo } from '../internal-models/common-models';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService extends BaseService {



  toasts: ToastInfo[] = [];
  public loaderInfo: LoaderInfo = { message: '', showLoader: false };
  // public confirmModalInfo:
  constructor(private modalService: NgbModal) {
    super();
  }


  async presentLoading(message: string = '') {
    this.loaderInfo = { message, showLoader: true };
  }

  async presentToast(toastInfo: ToastInfo) {
    this.toasts.push(toastInfo);
  }

  removeToast(toast: any) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  clearAllToasts() {
    this.toasts.splice(0, this.toasts.length);
  }

  async presentAlert() {

  }

  async presentConfirmAlert(modalInfo: ConfirmModalInfo): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmModalComponent);
    modalRef.componentInstance.confirmModalInfo = modalInfo;
    return await modalRef.result;
  }

  async dismissLoader() {
    this.loaderInfo.showLoader = false;
    this.loaderInfo.message = '';


  }

  async presentLoginModal(): Promise<boolean> {
    const modalRef = this.modalService.open(LoginComponent);
    // not needed
    // let req: TokenRequestSM = { companyCode: '', loginId: '', password: '', roleType: RoleTypeSM.ClientAdmin }
    // modalRef.componentInstance.viewModel.tokenRequest = req;
    return await modalRef.result;
  }

  

  closeModal(modal: TemplateRef<any>, result: boolean) {
    // this.modalService.open(modal).result.then(
    //   (result) => {
    //     this.closeResult = `Closed with: ${result}`;
    //   },
    //   (reason) => {
    //     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //   },
    // );
  }
  
 


}
